import strefy from "./strefy.json";
import type { POG__Zone } from "./types";

const POG__ZONES: Array<POG__Zone> = strefy;

const POG__ZONE_LABELS: Record<string, string> = Object.fromEntries(POG__ZONES.map((zone) => [zone.symbol, zone.label]));
const POG__ZONE_COLORS: Record<string, string> = Object.fromEntries(POG__ZONES.map((zone) => [zone.symbol, zone.color]));
const POG__ZONE_OPTIONS: Array<{ symbol: string; label: string }> = POG__ZONES.map((zone) => ({ symbol: zone.symbol, label: zone.label }));

const POG__ZONE_FALLBACK_COLOR = "#e0e0e0";

export { POG__ZONE_COLORS, POG__ZONE_FALLBACK_COLOR, POG__ZONE_LABELS, POG__ZONE_OPTIONS, POG__ZONES };
